import Header from "../sections/Header";
import Footer from "../sections/Footer";
import "../style/style.css";
import ServiceInfo from "../sections/ServiceInfo";
import { useParams, useNavigate } from "react-router-dom";
import { PATHS } from "../utils";
import useKontentServiceApi from "../services/useKontentServiceApi";
import { useEffect } from "react";

const ServiceInfoPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  // const validateURLParams = useCallback(
  //   (str: string) => {
  //     try {
  //       return atob(str);
  //     } catch (err) {
  //       navigate(PATHS.notFoundPage);
  //     }
  //   },
  //   [navigate]
  // );

  // slug will be the string from the URL, e.g., "operations-support"

  const { data, errorCode, loading } = useKontentServiceApi(slug || "", true, "service_content_info");

  useEffect(() => {
    if(slug && errorCode === 100){
      navigate(PATHS.notFoundPage);
    }
  },[slug, errorCode, navigate])

  if (!slug) {
    return <div>Invalid service link.</div>;
  }

  return (
    <>
      <Header loading={loading}/>
      <ServiceInfo data={data} />
      <Footer />
    </>
  );
};

export default ServiceInfoPage;
